export const isObjectHasValues = (obj: object): boolean => {
  return !!Object.keys(obj).length;
};
